import React, { useState, useEffect } from 'react'
import SponsorAgreementP1 from '../Agreement/components/Page1'
import { getAggreementFormReview } from "../../../auth/services/apiCalling"
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import { approve_reject } from "../../../auth/services/apiCalling";
import { submitContractFarmingFiles, submitContractFarmingFilesAgreement } from '../../../auth/services/privateapicalling';
import { sponsorRegistration } from '../../../../core/data/json/contractFarming';
import ReadOnlyAgreementForm from '../Agreement/components/ReadOnlyAgreementForm';

const StampPaperSponsor = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const appdata = location.state || '';
    const token = useSelector((state: any) => state.auth.token);
    const userDetail = useSelector((state: any) => state.auth.userDetails);
    const roleIdentifier = userDetail?.Role?.Role_Identifier;

    const [reviewedData, setreviewedData] = useState<any>();
    const [uploadLoading, setUploadLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        stampDoc: null as any,
    });
    const [conditionsData, setConditionsData] = useState<any>([]);
    const [rows, setRows] = useState<any>([]);

  

    const formReviewDetails = async () => {
        const resp = await getAggreementFormReview(token, appdata?.Sponsor_Id);
       
        if (resp?.success == true) {
            setreviewedData(resp?.data);
            if (resp?.data?.aggrement?.Cultivation) {
                setConditionsData(resp?.data?.aggrement?.Cultivation ? resp?.data?.aggrement?.Cultivation : sponsorRegistration);
            }
            if (resp?.data?.textField?.villageData) {
                setRows(resp.data.textField.villageData);
            }
        } else {
            toast.error(resp?.message);
        }
    }

    useEffect(() => {
    
        if (appdata?.Sponsor_Id) {
            formReviewDetails();
        }
    }, [appdata?.Sponsor_Id])

    const handleFileChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        fieldName: string
    ) => {
        const { files } = e.target;
        if (files && files.length > 0) {
            const file = files[0];
            const fileName = file.name;
            handleUpload(fileName, file, fieldName, formData[fieldName]?.docId);
        }
    };

    const handleUpload = async (
        documentName: string,
        file: any,
        fieldName: string,
        docId?: string | null
    ) => {
        // Validate applicationId exists
        if (!appdata?.Sponsor_Id) {
            toast.error("Application ID is missing. Please reload the page.", {
                position: "top-right"
            });
         
            return;
        }

        // Use same variable name as working file
        const formData = new FormData();
        formData.append("file", file);
        formData.append("documentName", fieldName);
        formData.append("fieldName", fieldName);
        formData.append("applicationId", String(appdata.Sponsor_Id));

      

        try {
            setUploadLoading(true);
            const res = await submitContractFarmingFilesAgreement(formData, token, docId);

           

            if (res.success == false) {
                toast.error(res?.message, { position: "top-right" });
            } else if (res.success && res.docId) {
                setFormData((prev) => ({
                    ...prev,
                    [fieldName]: {
                        docId: res.docId,
                        documentName: fieldName,
                        fileName: documentName,
                    },
                }));

                toast.success(res?.message || "File uploaded successfully", {
                    position: "top-right"
                });
            }
        } catch (error) {
           
            toast.error("File upload failed", { position: "top-right" });
        } finally {
            setUploadLoading(false);
        }
    };
   

    const handleForwardWithDocument = async () => {
        if (!formData.stampDoc?.docId) {
            toast.error("Please upload the signed agreement on stamp paper before proceeding", {
                position: "top-right"
            });
            return;
        }

        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            // Fix: Change the structure to match expected format
            const submittedFields = {
                reg: {
                    stampDoc: {
                        data: {
                            docId: formData.stampDoc.docId,
                            documentName: formData.stampDoc.documentName
                        }
                    }
                }
            };

            const deletedItemNos = conditionsData
                .filter((c: any) => c?.status === 'deleted')
                .map((c: any) => String(c.itemNo));

            // Fix: Change appStatusLevel to match expected value
            const payload: any = {
                applicationId: appdata?.Sponsor_Id,
                status: reviewedData?.buttonName[0]?.status,
                appStatusLevel: reviewedData?.buttonName[0]?.appStatusLevel, // Changed from "documentUploaded"
                comment: "", // Changed to empty string as per expected payload
                submittedFields: submittedFields, // Now uses the corrected structure
                // couchId: reviewedData?.applicationDataId,
                // textField,
                // aggrement,
                // deletedItemNos,
            };

           

            const res = await approve_reject(token, payload);

            if (res?.success == true) {
                toast.success("Document forwarded successfully", { position: "top-right" });

                // Properly close modal and clean up
                const modalElement = document.getElementById('uploadDoc');
                const modal = (window as any).bootstrap?.Modal?.getInstance(modalElement);

                if (modal) {
                    modal.hide();
                }

                // Remove modal backdrop and body classes
                setTimeout(() => {
                    const backdrop = document.querySelector('.modal-backdrop');
                    if (backdrop) {
                        backdrop.remove();
                    }
                    document.body.classList.remove('modal-open');
                    document.body.style.removeProperty('overflow');
                    document.body.style.removeProperty('padding-right');

                    // Navigate after cleanup
                    navigate("/sponsor-menu");
                }, 500);
            } else {
                toast.error(res?.message || "Failed to forward document", {
                    position: "top-right",
                    toastId: 'forward-error'
                });
            }
        } catch (error) {
            
            toast.error("Failed to forward document", { position: "top-right" });
        } finally {
            setIsSubmitting(false);
        }


    };

    return (
        <div className='page-wrapper'>
            {(appdata?.appStatusLevel == "forwardToSponsorAterApproval" || appdata?.appStatusLevel == "forwardToSpoAfterApprovalResubmissionn") &&
                <div className='d-flex p-5 justify-content-between w-100'>
                    {appdata?.appStatusLevel == "forwardToSponsorAterApproval" && (<div>
                        <h3>Agreement Approved - Next Step Required</h3>
                        <p className='fs-17 mb-2'>As part of the agreement process, you are required to upload a signed agreement on a ₹300 stamp paper. The agreement must include all terms and conditions mutually accepted with the farmers/organization.</p>
                    </div>)}
                    {appdata?.appStatusLevel == "forwardToSpoAfterApprovalResubmissionn" && (<div>
                        <h3>Agreement Query Raised - Try to Upload the Doc again</h3>
                        <p className='fs-17'>As part of the agreement process, you are required to upload a signed agreement on a ₹300 stamp paper. The agreement must include all terms and conditions mutually accepted with the farmers/organization.</p>
                    </div>)}
                    <div className='w-25  d-flex align-items-center justify-content-end'>
                        <button
                            className="btn btn-info"
                            data-bs-target="#uploadDoc"
                            data-bs-toggle="modal"
                            data-bs-dismiss="modal"
                            disabled={!appdata?.Sponsor_Id}
                        >
                            <i className='feather feather-plus-circle pe-2'></i>
                            Upload Document
                        </button>
                    </div>
                </div>
            }
            {roleIdentifier === "SPO" && reviewedData?.appStatusLevel == "forwardToSpoAfterApprovalResubmissionn" && (
                <div className="mx-5 mb-4">
                    <h4>Comment from</h4>
                    <p className="fw-bold text-black" style={{ fontSize: "1.4rem" }}>
                        Marketing Board Administrator:
                        <span className="fw-normal bg-white p-2 rounded border border-secondary d-block mt-2 text-break" style={{ fontSize: "1.2rem" }}>
                            {reviewedData?.forwardToMBMDAterApproval?.comment}
                        </span>
                    </p>
                </div>
            )}
            {/* <SponsorAgreementP1
                    conditionsData={conditionsData}
              setConditionsData={setConditionsData}
                onNext={handleNext}
                reviewedData1={reviewedData || {}}
                isEnable1={true}
                appdata1={appdata || {}}
                licenseProof1={{ data: formData.stampDoc }}
            /> */}

            <ReadOnlyAgreementForm
                applicationId={appdata?.Sponsor_Id}
            />

            <div
                className="modal fade"
                id="uploadDoc"
                aria-hidden="true"
                aria-labelledby="exampleModalToggleLabel2"
                tabIndex={-1}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="exampleModalToggleLabel2">
                                Upload Document
                            </h4>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <div className="modal-body">
                                <div className="bg-gray rounded-3 border border-dark-subtle p-3">
                                    <div className="mb-3">
                                        <h5>Document Required</h5>
                                        <p>
                                            Upload a Signed Agreement On a ₹300 Stamp Paper.
                                        </p>
                                    </div>

                                    {formData.stampDoc?.fileName && (
                                        <div className="alert alert-success mb-2">
                                            <small>✓ Uploaded: {formData.stampDoc.fileName}</small>
                                        </div>
                                    )}

                                    <input
                                        type="file"
                                        className="form-control w-100 mb-2"
                                        onChange={(e) => handleFileChange(e, 'stampDoc')}
                                        name='stampDoc'
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        disabled={uploadLoading || !appdata?.Sponsor_Id}
                                    />

                                    {!appdata?.Sponsor_Id && (
                                        <div className="alert alert-warning mb-2">
                                            <small>⚠ Application ID is missing. Please reload the page.</small>
                                        </div>
                                    )}

                                    <button
                                        type="button"
                                        className="btn btn-info me-3 my-2 w-100"
                                        onClick={handleForwardWithDocument}
                                        disabled={uploadLoading || isSubmitting || !formData.stampDoc?.docId}
                                    >
                                        {uploadLoading ? 'Uploading...' : isSubmitting ? 'Forwarding...' : 'Submit & Forward'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer />
        </div>
    )
}

export default StampPaperSponsor